export const formatPercent = (percent: number) => {
  if (percent > 0) {
    return `+${(percent * 100).toFixed(1)}%`;
  }
  return `${(percent * 100).toFixed(1)}%`;
};
